import { render } from "./AudioRecorder.vue?vue&type=template&id=5ca99248&scoped=true"
import script from "./AudioRecorder.vue?vue&type=script&lang=js"
export * from "./AudioRecorder.vue?vue&type=script&lang=js"

import "./AudioRecorder.vue?vue&type=style&index=0&id=5ca99248&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5ca99248"]])

export default __exports__